import { setSessionData } from '../sessionStorage/sessionStorage';

// these courses redirect to other ones but share the same title so need to be removed
const knownRedirects = [
  'smartchoice.oxfordonlinepractice.com',
  'teamupplus.oxfordonlinepractice.com',
  'stepsplus.oxfordonlinepractice.com',
];

/**
   * Create a new object without courses that have vanity urls or local urls
   * @param {object} obj - object with urls as keys and course titles as values
   * @returns {object} new object with only keys that contain .oxfordonlinepractice.com
   */
function removeVanityUrls(obj) {
  const clonedObj = { ...obj };
  Object.keys(clonedObj).forEach((key) => {
    if (!key.includes('.oxfordonlinepractice.com')) {
      delete clonedObj[key];
    }
  });
  return clonedObj;
}

/**
   * Create a new object without known redirects
   * @param {object} obj - object with urls as keys and course titles as values
   * @param {array} urlArray - array of urls that redirect to other courses
   * @returns {object} new object with only keys that contain .oxfordonlinepractice.com
   */
function removeRedirects(obj, urlArray) {
  const clonedObj = { ...obj };
  urlArray.forEach((url) => {
    delete clonedObj[url];
  });
  return clonedObj;
}

/**
   * Find the first Objects key whose value matches passed value
   * @param {object} obj
   * @param {string|number|object|array|} value
   * @returns {string} the found key
   */
function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}


const storeCourseUrl = (courseTitle) => {
  fetch('https://api.oxfordonlinepractice.com/api/products/domains')
    .then((response) => {
      if (response.ok) return response.json();
      return Promise.reject(response.status);
    })
    .then((json) => {
      const cleanObject = removeVanityUrls(removeRedirects(json.data, knownRedirects));

      const courseUrl = getKeyByValue(cleanObject, courseTitle);

      if (courseUrl !== undefined) {
        setSessionData({ value: courseUrl, key: 'url' });
      }
    })
    .catch(response => console.error(response)); // 404
};

export default storeCourseUrl;



// WEBPACK FOOTER //
// ./src/components/storeCourseUrl/storeCourseUrl.js